//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import utils from "@/utils"
import api from "@/api"
import { setInterval } from 'timers';
export default {
    data () {
        return {
            dialogVisible2: true,
            interval:'',
        }
    },
    created(){
        
    },
    mounted () {
       
    },
    methods:{
        closeEnd () {
            let  _this = this
            _this.dialogVisible2 = false;
            window.clearInterval(_this.interval)
        },
    }
}



// WEBPACK FOOTER //
// ./src/components/dialog/NoticeView.vue